<template>
  <div class="row" style="margin-top: 15px">
    <fieldset>
      <legend style="width: 440px">Quantidade de atendimento por paciente</legend>
      <div class="row">
        <div class="title-group">Período</div>
        <div class="group-itens">
          <div class="item-filter">
            <a-date-picker show-time type="date" placeholder="Data Início" style="width: 100%" format="DD/MM/yyyy" v-model:value="form.dtIni" />
          </div>
          <div class="item-filter">
            <a-date-picker show-time type="date" placeholder="Data Fim" style="width: 100%" format="DD/MM/yyyy" v-model:value="form.dtFim" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="title-group">Paciente</div>
        <div class="group-itens">
          <div class="item-filter">
            <select class="form-select" v-model="form.pessoaFisicaNome">
              <option></option>
              <option v-for="item in this.lstPaciente" :key="item.nome" :value="item.nome">
                {{ item.nome }}
              </option>
            </select>
          </div>
          <div class="item-filter">
            <label class="form-check-label" for="todos">Todos </label>
            <input class="form-check-input" type="checkbox" id="todos" v-model="form.todos" />
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 15px">
        <div style="width: 180px">
          <a-tooltip title="Pesquisar" placement="top">
            <div class="input-group-prepend icon" style="text-align: center">
              <span class="input-group-text bg-white" @click="searchData">
                <i class="fa fa-search" style="margin: 0px 10px"></i>
                <span>Pesquisar</span>
              </span>
            </div>
          </a-tooltip>
        </div>
        <div class="col"></div>
        <div style="display: flex; flex-direction: row; width: 380px">
          <div style="width: 150px">
            <a-tooltip title="Imprimir" placement="top" v-if="dadosTabela.length > 0" @click="imprimirPDF">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-print" style="margin: 0px 10px"></i>
                  <span>Imprimir</span>
                </span>
              </div>
            </a-tooltip>
          </div>
          <div style="width: 170px">
            <a-tooltip title="Imprimir" placement="top" v-if="dadosTabela.length > 0" @click="encaminharEmail">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-share" style="margin: 0px 10px"></i>
                  <span>Encaminhar</span>
                </span>
              </div>
            </a-tooltip>
          </div>
        </div>
        <div class="row" style="margin-top: 10px">
          <a-table :dataSource="dadosTabela" :columns="columns"> </a-table>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { gerarRelatorioAtendimentoQtdePorPaciente } from '@/components/service/registroAtendimentoService';
import { gerarRelatorioHtml, gerarRelatorioPdf } from '@/components/service/gerarRelatorio';
import { abrirImpressaoPorBlob, encaminharEmailTo } from '@/utils/servicos-utils';
import { getListaResumidaPaciente } from '@/components/service/pacienteService';

export default {
  name: 'AtendimentoPacienteRelatorio',
  data() {
    return {
      dadosTabela: [],
      lstPaciente: [],
      form: {
        dtIni: undefined,
        dtFim: undefined,
        todos: true,
        pessoaFisicaNome: undefined,
      },
      columns: [
        {
          title: 'Nome do Paciente',
          dataIndex: 'descricao',
          key: 'descricao',
        },
        {
          title: 'Quantidade',
          dataIndex: 'quantidade',
          key: 'quantidade',
        },
      ],
    };
  },

  methods: {
    async searchData() {
      await gerarRelatorioAtendimentoQtdePorPaciente(this.form)
        .then((r) => {
          this.dadosTabela = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async imprimirPDF() {
      if (this.dadosTabela.length > 0) {
        await gerarRelatorioPdf({
          listaDadosDocumento: this.dadosTabela,
          nomeDocumentoHtml: 'relatorio-qtde-atendimento-por-paciente.html',
        }).then((r) => {
          abrirImpressaoPorBlob(r.data);
        });
      }
    },
    async encaminharEmail() {
      if (this.dadosTabela.length > 0) {
        await gerarRelatorioHtml({
          listaDadosDocumento: this.dadosTabela,
          nomeDocumentoHtml: 'relatorio-qtde-atendimento-por-paciente.html',
        }).then((r) => {
          encaminharEmailTo('Relatório de Atendimentos por Paciente', r.data, document.getElementById('sendMail'));
        });
      }
    },
    async carregarPacientes() {
      await getListaResumidaPaciente()
        .then((r) => {
          this.lstPaciente = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  created() {
    this.carregarPacientes();
  },
};
</script>

<style scoped>
.title-group {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: bold;
}

.group-itens {
  display: flex;
  flex-direction: row;
}

.form-check-label {
  font-size: 14px;
  margin: 0px 10px;
}

.input-group-prepend {
  cursor: pointer;
}

.input-group-text {
  padding: 0.375rem 26px 4px 11px;
  height: 38px;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  background: #2bec96 !important;
}

.icon {
  cursor: pointer;
}

.item-filter {
  margin: 10px;
}

.item-filter.form-check-input {
  margin: 10px;
}
</style>
